import { buildGridRowsAndTiers } from "./buildGridRowsAndTiers";
export function calculateGridPartDimensions({ tiersArray, rowsArray, containerWidth, containerHeight, displayNumbers, cellSeparation = 0, }) {
    const addLeftWidth = Number(!!displayNumbers.left) * containerWidth, addRightWidth = Number(!!displayNumbers.right) * containerWidth, addTopHeight = Number(!!displayNumbers.top) * containerHeight, addBottomHeight = Number(!!displayNumbers.bottom) * containerHeight;
    const numberOfTiers = tiersArray.length, numberOfRows = rowsArray.length;
    const widthOfCells = containerWidth * numberOfRows + cellSeparation * (numberOfRows - 1), heightOfCells = containerHeight * numberOfTiers + cellSeparation * (numberOfTiers - 1);
    const widthOfGrid = addLeftWidth + widthOfCells + addRightWidth;
    const heightOfGrid = addTopHeight + heightOfCells + addBottomHeight;
    const cellPositions = {};
    const tiersArraySortedDesc = tiersArray.sort(sortDesc);
    // Boxes for each cell
    for (let t = 0; t < numberOfTiers; t += 1) {
        for (let c = 0; c < numberOfRows; c += 1) {
            const name = `${rowsArray[c]}|${tiersArraySortedDesc[t]}`;
            const x = addLeftWidth + c * containerWidth + cellSeparation * c;
            const y = addTopHeight + t * containerHeight + cellSeparation * t;
            cellPositions[name] = { x, y };
        }
    }
    return {
        numberOfTiers,
        numberOfRows,
        addLeftWidth,
        addRightWidth,
        addTopHeight,
        addBottomHeight,
        widthOfCells,
        heightOfCells,
        widthOfGrid,
        heightOfGrid,
        cellPositions,
    };
}
export function calculateGridFromConfigDimensions({ minAboveTier, maxAboveTier, minBelowTier, maxBelowTier, centerLineRow, aboveCenterLineRow, belowCenterLineRow, maxRow, containerWidth, containerHeight, cellSeparation, belowGridSeparation, }) {
    var _a, _b;
    const { aboveRowsArray, belowRowsArray, aboveTiersArray, belowTiersArray } = buildGridRowsAndTiers({
        minAboveTier,
        maxAboveTier,
        minBelowTier,
        maxBelowTier,
        centerLineRow,
        aboveCenterLineRow,
        belowCenterLineRow,
        maxRow,
    });
    const aboveDimensions = aboveTiersArray
        ? calculateGridPartDimensions({
            tiersArray: aboveTiersArray,
            rowsArray: aboveRowsArray,
            containerWidth,
            containerHeight,
            displayNumbers: { left: true, right: true, top: true },
            cellSeparation,
        })
        : undefined;
    const belowDimensions = belowTiersArray
        ? calculateGridPartDimensions({
            tiersArray: belowTiersArray,
            rowsArray: belowRowsArray,
            containerWidth,
            containerHeight,
            displayNumbers: { left: true, right: true, bottom: true },
            cellSeparation,
        })
        : undefined;
    // Same layout as createBayGrid: the narrower part is centered
    const width = Math.max((_a = aboveDimensions === null || aboveDimensions === void 0 ? void 0 : aboveDimensions.widthOfGrid) !== null && _a !== void 0 ? _a : 0, (_b = belowDimensions === null || belowDimensions === void 0 ? void 0 : belowDimensions.widthOfGrid) !== null && _b !== void 0 ? _b : 0);
    const cellPositions = {};
    let height = 0;
    if (aboveDimensions) {
        addOffsetCellPositions(aboveDimensions.cellPositions, (width - aboveDimensions.widthOfGrid) * 0.5, 0, cellPositions);
        height = aboveDimensions.heightOfGrid;
        if (belowDimensions)
            height += belowGridSeparation;
    }
    if (belowDimensions) {
        addOffsetCellPositions(belowDimensions.cellPositions, (width - belowDimensions.widthOfGrid) * 0.5, height, cellPositions);
        height += belowDimensions.heightOfGrid;
    }
    return {
        width,
        height,
        cellPositions,
        aboveDimensions,
        belowDimensions,
    };
}
function addOffsetCellPositions(source, dx, dy, target) {
    Object.keys(source).forEach((k) => {
        target[k] = { x: source[k].x + dx, y: source[k].y + dy };
    });
}
function sortDesc(a, b) {
    return Number(b) - Number(a);
}
